import {t} from '../l10n';

const moment = require('moment');

export function formatDate(virtualGift, extended) {
    let format = t('MM/DD/YYYY');

    if (extended) {
        format = t('MM/DD/YYYY [at] HH:mm');
    }

    return moment(virtualGift.date).format(format)
}


// WEBPACK FOOTER //
// ./src/utils/virtualGifts.js